namespace TabAurous.OMS {
    export interface TaxRow {
        TaxId?: number;
        TaxType?: string;
        TaxName?: string;
        GroupId?: number;
        ApplicableOn?: string;
        Rate?: number;
        CalculatingMode?: string;
        Narration?: string;
        FixedName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        HasThreshold?: boolean;
        ThresholdValue?: number;
        SingleTrans?: number;
        CumulativeTrans?: number;
        IsDisabled?: boolean;
        ProductType?: number[];
        ItemDetails?: TaxDetailsRow[];
    }

    export namespace TaxRow {
        export const idProperty = 'TaxId';
        export const nameProperty = 'TaxName';
        export const localTextPrefix = 'OMS.Tax';
        export const lookupKey = 'Tax';

        export function getLookup(): Q.Lookup<TaxRow> {
            return Q.getLookup<TaxRow>('Tax');
        }
        export const deletePermission = 'Masters:Tax:Delete';
        export const insertPermission = 'Masters:Tax:Add';
        export const readPermission = '*';
        export const updatePermission = 'Masters:Tax:Edit';

        export declare const enum Fields {
            TaxId = "TaxId",
            TaxType = "TaxType",
            TaxName = "TaxName",
            GroupId = "GroupId",
            ApplicableOn = "ApplicableOn",
            Rate = "Rate",
            CalculatingMode = "CalculatingMode",
            Narration = "Narration",
            FixedName = "FixedName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            HasThreshold = "HasThreshold",
            ThresholdValue = "ThresholdValue",
            SingleTrans = "SingleTrans",
            CumulativeTrans = "CumulativeTrans",
            IsDisabled = "IsDisabled",
            ProductType = "ProductType",
            ItemDetails = "ItemDetails"
        }
    }
}
